import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import { Icon } from "./icon";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-input group-[.toaster]:shadow-lg min-h-20",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        },
      }}
      icons={{
        success: <Icon name="check" className="text-lg" />,
        loading: <Icon name="spinner" className="animate-spin" />,
        error: <Icon name="x" />,
      }}
      {...props}
    />
  );
};

export { Toaster };
